/**常量 */

//默认每页显示数量
const pageSize = 6;

//手机号正则
const pattern_phone = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;

//发薪审核进度
const salaryapply_step = [
  { Key: 0, Text: "业务待审", Color: "#ffa500" },
  { Key: 1, Text: "财务待审", Color: "#ffa500" },
  { Key: "2-1", Text: "总经理待审", Color: "#ffa500" },
  { Key: "2-2", Text: "正常发放通过", Color: "#080" },
  { Key: 3, Text: "欠款发放通过", Color: "#080" },
];

//发薪审核类型
const salaryapply_type = [
  { Key: 1, Text: "业务审核", Color: "#1e90ff" },
  { Key: 2, Text: "财务审核", Color: "#ffa500" },
  { Key: 3, Text: "总经理审核", Color: "#f00" },
];

//发薪审核类型
const salaryapply_status = [
  { Key: 0, Text: "待审核" },
  { Key: 1, Text: "审核通过", Color: "#080" },
  { Key: 2, Text: "审核不通过", Color: "#f00" },
];

export default {
  pageSize,
  pattern_phone,
  salaryapply_step,
  salaryapply_type,
  salaryapply_status,
};
